module.exports = __webpack_public_path__ + "static/media/scene7_furba2.dd846f4c.wav";